<template>
    <div class="card" v-on:click="onCardClick(entry)">
        <img v-if="image" class="image" :src="image.fields.file.url"  v-bind:style="{ 'height': imageHeight}">
        <div v-if="citation" class="citation">
            <p>{{entry.fields.citation}}</p>
        </div>
        <div class="title" v-bind:style="{ 'height': titleHeight}">
            <p>
                {{entry.fields.title}}<br>
                <span v-if="subTitle">{{entry.fields.subTitle}}</span>
            </p>
        </div>
        <div class="bottom-bar"><p>{{action}}</p></div>
    </div>
</template>

<script>
    export default {
        name: "Card",
        props: {
            entry: {
                type: Object,
                default: null
            },
            image: {
                type: Object,
                default: null
            },
            citation: {
                type: Boolean,
                default: false
            },
            subTitle: {
                type: Boolean,
                default: false
            },
            action: {
                type: String,
                default: 'Saiba Mais'
            },
            titleHeight: {
                type: String,
                default: '8em'
            },
            imageHeight: {
                type: String,
                default: '12em'
            }
        },
        methods: {
            onCardClick(entry) {
                this.$emit('card-selection', entry);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .card {
        margin-bottom: 2em;
        height: 22em;
        background-color: $bgcolor-grey;
        position: relative;

        &:hover {
            cursor: pointer;
        }

        .title {
            position: absolute;
            width: 100%;
            bottom: 2em;
            z-index: 2;
            height: 8em;
            background-color: $bgcolor-alternative;
            max-height: 80%;

            &:hover {
                cursor: pointer;
            }
            p {
                // padding-left: 1em;
                // padding-right: 1em;
                // padding-top: 1em;
                cursor: default;
                font-weight: 800;
                font-size: 1.5em;
                letter-spacing: 0.15em;
                font-family: "Merriweather", serif;
                font-style: italic;
                width: 90%;
                text-align: center;
                color: $bgcolor-grey;

                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                margin-block-start: 0em;
                margin-block-end: 0em;
                &:hover {
                    cursor: pointer;
                }

                span {
                    font-style: normal;
                    font-family: "Work Sans";
                    font-size: 0.7em;
                    letter-spacing: 0.1em;
                    font-weight: 500;
                    text-transform: uppercase;
                }
            }
        }
        .bottom-bar {
            height: 2em;
            width: 100%;
            position: absolute;
            bottom: 0;
            z-index: 2;
            background-color: $primary;

            &:hover {
                cursor: pointer;
            }

            p {
                margin-block-end: 1em !important;
                margin-block-start: 0.9em !important;
                cursor: default;
                font-weight: 600;
                font-size: 0.7em;
                text-transform: uppercase;
                color: $bgcolor-grey;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .image {
            height: 12em;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            object-fit: cover;
            object-position: center;

            filter: brightness(80%);

            -webkit-transition : -webkit-filter 200ms linear;

            &:hover {
                cursor: pointer;
            }
        }

        .citation {
            height: 12em;
            position: absolute;
            width: 100%;

            p {
                cursor: default;
                font-weight: 600;
                font-size: 1.7em;
                letter-spacing: 0.15em;
                font-family: "Merriweather", serif;
                font-style: italic;
                width: 90%;
                text-align: center;

                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                margin-block-start: 0em;
                margin-block-end: 0em;

            }
        }


        &:hover {
            background-color: $bgcolor;
            .bottom-bar {
                background-color: $bgcolor-grey;
                p {
                    color: $primary;
                }
            }

            .image {
                filter: brightness(100%);
            }
        }
    }

</style>
